@for (aldersGruppe of getAldersgrupper(); track $index) {

  @for (loebende of getUdbetalingsTyper(); track loebende) {

    @if (aldersGruppe.text !== 'Alle') {
      <h2>{{ aldersGruppe.text }} / {{ loebende ? 'Løbende udbetaling' : 'Engangsudbetaling' }}</h2>
    } @else {
      <h2>{{ loebende ? 'Løbende udbetaling' : 'Engangsudbetaling' }}</h2>
    }

    @for (prisGruppe of getPrisgrupper(); track prisGruppe) {
      @let data = getData(loebende, prisGruppe, aldersGruppe);
      @if (data.length > 0) {
        <h3 class="mb-2">Prisgruppe {{ prisGruppe }}</h3>
        <div>{{getHelpText(plService.produktType()!.produktTypeNummer, data[0].underKode)}}</div>
        <table class="detail-table bordered w-full">
          <thead>
          <tr>
            <th
              style="width:150px">{{ plService.produktType()?.navn?.includes('helbred') ? 'Maksimal dækning' : 'Dækning' }}
            </th>
            <th style="width:150px">Årlig pris</th>
            <th style="width:150px">Rap-nr</th>
          </tr>
          </thead>
          @for (item of data; track item.id) {
            <tr>
              <td>{{ item.ydelse || 5000000 | number:'1.0' }} kr.</td>
              <td>{{ item.pris | number:'1.0' }} kr.</td>
              <td>{{ plService.produktType()?.produktTypeNummer }}-{{ item.underKode|number:'3.0' }}</td>
            </tr>
          }
        </table>
      }
    }
    <br />
  }

}

